/** Format WTF for Dutch UI (comma decimal), default 4 fraction digits. */
export const formatWtfNl = (value, fractionDigits = 4) => {
    const number = Number(value);
    if (Number.isNaN(number)) {
        return (0).toFixed(fractionDigits).replace('.', ',');
    }
    return number.toFixed(fractionDigits).replace('.', ',');
};

/** Parse Dutch or English decimal string to number. */
export const parseWtfNl = (value) => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }
    const normalized = String(value).trim().replace(',', '.');
    const number = Number(normalized);
    return Number.isNaN(number) ? 0 : number;
};
